import Vue from 'vue'
import Router from 'vue-router'

import Dashboard from '@/components/Dashboard'
import Home from '@/components/Home'
import Users from '@/components/Users'
import AddContract from '@/components/AddContract'
import Form from '@/components/Form'
import Reports from '@/components/Reports'
import Login from '@/components/Login'
import SignUp from '@/components/SignUp'
import Teams from '@/components/Teams'
import YourTeam from '@/components/YourTeam'
import firebase from 'firebase'

Vue.use(Router)

let router = new Router({
  mode: 'history',
  routes: [
    {
      path: '*',
      redirect: '/login'
    },
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    {
      path: '/sign-up',
      name: 'SignUp',
      component: SignUp
    },
    {
      path: '/',
      name: 'Home',
      component: Home,
      meta: {
        requiresAuth: true
      },
      children: [
        {path: '', component: Form, name: 'Status Reports'},
        {path: 'dashboard', component: Dashboard, name: 'Dashboard'},
        {path: 'addContract', component: AddContract, name: 'Current Contracts'},
        {path: 'users', component: Users, name: 'Users'},
        {path: 'reports', component: Reports, name: 'Reports'},
        {path: 'teams', component: Teams, name: 'Teams'},
        {path: 'your-team', component: YourTeam, name: 'Your Team'}
      ]
    }
  ]
})

router.beforeEach((to, from, next) => {
  console.log('chnaged route')
  let currentUser = firebase.auth().currentUser;
  let requiresAuth = to.matched.some(record => record.meta.requiresAuth);

  if (requiresAuth && !currentUser) next('login')
  else if (!requiresAuth && currentUser) next('dashboard')
  else next()
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js